import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getToken } from './Common'

const PrivateRoute = ({ component: Component, ...rest}) => {
    return getToken() ? <Outlet /> : <Navigate to="/login" />
}

export default PrivateRoute
